import { useAuth } from '@/contexts/AuthContext'
import { useSessionTimeout } from '@/hooks/useSessionTimeout'
import { getSessionTimeoutMs } from '@/lib/sessionTimeout'

import { LockScreen } from './LockScreen'

export function SessionGuard({ children }) {
  const { isAuthenticated, screenLocked, lock } = useAuth()

  useSessionTimeout({
    enabled: isAuthenticated && !screenLocked,
    timeoutMs: getSessionTimeoutMs(),
    onTimeout: () => {
      lock()
    },
  })

  return (
    <>
      {children}
      {isAuthenticated && screenLocked ? <LockScreen /> : null}
    </>
  )
}
